<template>
  <div class="row tools">
    <div class="col-md-12">
      <router-link tag="button" :to="{ path: path }" class="btn" :class="'btn-' + color">
        <i v-if="icon" :class="icon"></i>
        {{name}}
      </router-link>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      path: {
        type: String,
        default: ''
      },
      name: {
        type: String,
        default: ''
      },
      color: {
        type: String,
        default: 'default'
      },
      icon: {
        type: [String, null],
        default: null
      }
    }
  }
</script>

<style scoped>

</style>
